export const changeLocationHash = (newHash: string) => {
  var url = new URL(window.location.href)
  url.hash = newHash

  window.history.pushState({}, "", url.toString())
}
